import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
export const StyledFaqWrapper = styled('div')(
  ({ theme }) => `
    flex: 1;
    margin-bottom: 3.75rem;

    > div:first-child:has(h3), div:first-child:has(h2) {
     margin-top: -${theme.DS_spacing(['xl'])};

    }
    
    .MuiAccordionDetails-root {
      padding-top: ${theme.DS_spacing(['sm'])};
    }
    
    ${theme.breakpoints.up('lg')} {
      margin-bottom: 0;
      flex: 0.48;
    }
  `,
);

export const StyledInfoHeadline = styled(Typography)(
  ({ theme }) => `
   margin-left: ${theme.DS_spacing(['xxs'])};
   margin-top:${theme.DS_spacing(['xl'])};
   margin-bottom:${theme.DS_spacing(['sm'])};
   text-align: left;
  
  `,
);
